// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8042":"f2bb8880","9080":"5681cf0a"}[chunkId] + ".chunk.css";
};